const module = { name: 'theater/details/shared/nonTicketingPopup', exports: {} }; const exports = module.exports;



import { Fandango_Dialog as Dialog } from 'require-global';



import { Fandango_popup as popup } from 'base-libraries';



import { default as tdpLocationHelper } from 'swug-fdRequire-call:theater/shared/tdpLocationHelper';



const Selectors = {
    NON_TICKETING_POPUP: '#non-ticketing-theater-popup',
    MODAL: '#non-ticketing-theater-modal',
    MODAL_CLOSE_BTN: '#non-ticketing-theater-modal-close-btn',
    MODAL_LINK: '#non-ticketing-theater-modal-link',
}


const SHOW_DIALOG_DELAY = 900
function updateModalLink() {
    const link = document.querySelector(Selectors.MODAL_LINK);
    link && (link.href = tdpLocationHelper.getShowtimesURL(link.href));
}
function showModal() {
    if (!document.querySelector(Selectors.MODAL)) {
        return;
    }
    updateModalLink();
    const dialog = new Dialog(Selectors.MODAL);
    document.querySelector(Selectors.MODAL_CLOSE_BTN).addEventListener('click', () => dialog.close());
    setTimeout(() => dialog.open(), SHOW_DIALOG_DELAY);
}
function showPopup() {
    setTimeout(() => {
        const currentPopup = popup.getCurrent();
        if (currentPopup || !document.querySelector(Selectors.NON_TICKETING_POPUP)) {
            return;
        }
        popup
            .attach(Selectors.NON_TICKETING_POPUP)
            .open();
    }, SHOW_DIALOG_DELAY);
}
function show(isDesktop) {
    return isDesktop ? showModal() : showPopup();
}
module.exports = {
    show
};
export default module.exports;